import api from "./api";

// 🔹 Register User
export const registerUser = async (userData) => {
  return await api.post("/auth/register/user", userData);
};

// 🔹 Login User
export const loginUser = async (credentials) => {
  return await api.post("/auth/login", credentials);
};
